/* eslint-disable import/prefer-default-export */
import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export function getDefaultPeriodCondition(eventDatetime) {
  return {
    startDatetime: moment(eventDatetime).subtract(2, 'h').toDate(),
    endDatetime: moment(eventDatetime).add(1, 'h').toDate(),
  };
}

export function getLogPeriodCondition(eventDatetime) {
  return {
    startDatetime: moment(eventDatetime).subtract(30, 'm').toDate(),
    endDatetime: moment(eventDatetime).add(30, 'm').toDate(),
  };
}

export function getConfigPeriodCondition(eventDatetime) {
  return {
    startDatetime: moment(eventDatetime).subtract(1, 'h').toDate(),
    endDatetime: moment(eventDatetime).add(1, 'h').toDate(),
  };
}

export function getEventPeriodCondition(eventDatetime) {
  return {
    startDatetime: moment(eventDatetime).subtract(60, 'm').toDate(),
    endDatetime: moment(eventDatetime).add(30, 'm').toDate(),
  };
}

export function getDateLabel(date) {
  return moment(date).format(DATE_FORMAT);
}

export function getPeriodConditionLabel(startDatetime, endDatetime) {
  return `${getDateLabel(startDatetime)} ~ ${getDateLabel(endDatetime)}`;
}



// WEBPACK FOOTER //
// ./src/components/popup/FaultAnalysisPopup/utils/fault-analysis.js